// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6twPN","top":"styles_top__3QKLt"};